import { Link as Anchor } from 'react-router-dom'

import styled from 'styled-components'

export const WrapperHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  width: 100%;
  height: 70px;
  background: rgba(255, 255, 255, 0.98);
  border-bottom: 1px solid rgba(40, 40, 40, 0.08);
  box-shadow: 0 6px 24px rgba(30, 30, 30, 0.06);
  backdrop-filter: blur(12px);
`

export const HeaderInner = styled.div`
  width: min(1540px, calc(100% - 48px));
  height: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 24px;

  @media (max-width: 1100px) {
    width: calc(100% - 28px);
    gap: 14px;
  }

  @media (max-width: 760px) {
    width: calc(100% - 24px);
    grid-template-columns: 1fr auto;
    gap: 12px;
  }
`

export const BrandLink = styled(Anchor)`
  justify-self: start;
  display: inline-flex;
  align-items: center;
  min-width: 0;
`

export const Image = styled.img`
  display: block;
  height: 54px;
  width: auto;
  object-fit: contain;

  @media (max-width: 900px) {
    height: 44px;
  }

  @media (max-width: 620px) {
    height: 40px;
  }
`

export const NavCapsule = styled.nav`
  justify-self: center;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px;
  border-radius: 999px;
  background: #f4f2ed;
  border: 1px solid rgba(40, 40, 40, 0.05);

  @media (max-width: 760px) {
    display: none;
  }
`

type NavItemProps = {
  $active?: boolean
}

export const NavItem = styled(Anchor)<NavItemProps>`
  min-height: 42px;
  padding: 0 22px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: ${({ $active }) => ($active ? '#e90000' : '#3f3f3f')};
  background: ${({ $active }) => ($active ? '#ffffff' : 'transparent')};
  box-shadow: ${({ $active }) =>
    $active ? '0 2px 12px rgba(30, 30, 30, 0.08)' : 'none'};
  font-size: 15px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  white-space: nowrap;
  transition: all 0.2s ease;

  svg {
    font-size: 18px;
  }

  &:hover {
    color: #e90000;
    background: rgba(255, 255, 255, 0.7);
  }

  @media (max-width: 1100px) {
    padding: 0 15px;
    font-size: 14px;
    gap: 8px;
  }

  @media (max-width: 780px) {
    width: 42px;
    padding: 0;

    span {
      display: none;
    }
  }
`

export const RightArea = styled.div`
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: 0;

  @media (max-width: 1100px) {
    gap: 10px;
  }

  @media (max-width: 760px) {
    display: none;
  }
`

export const CreateRouteLink = styled(Anchor)`
  min-height: 44px;
  padding: 0 22px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: #ffffff;
  background: #e90000;
  box-shadow: 0 8px 18px rgba(233, 0, 0, 0.18);
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s ease;

  svg {
    font-size: 15px;
  }

  &:hover {
    color: #ffffff;
    background: #cc0000;
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(233, 0, 0, 0.23);
  }

  @media (max-width: 1100px) {
    padding: 0 16px;
    font-size: 14px;
  }

  @media (max-width: 680px) {
    width: 42px;
    min-height: 42px;
    padding: 0;

    span {
      display: none;
    }
  }
`

export const UserMenu = styled.div`
  position: relative;
`

export const UserTrigger = styled.button`
  min-height: 44px;
  padding: 0 4px;
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  color: #363636;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;

  > svg:first-child {
    font-size: 31px;
    color: #3f3f3f;
  }

  &:hover {
    color: #e90000;
  }

  @media (max-width: 900px) {
    span {
      display: none;
    }
  }
`

type ChevronIconProps = {
  $open?: boolean
}

export const ChevronIcon = styled.span<ChevronIconProps>`
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
  transition: transform 0.2s ease;
`

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 180px;
  padding: 7px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid rgba(40, 40, 40, 0.08);
  box-shadow: 0 14px 36px rgba(30, 30, 30, 0.14);
`

export const DropdownLink = styled(Anchor)`
  width: 100%;
  min-height: 38px;
  padding: 0 12px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  color: #333333;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    color: #e90000;
    background: #faf4f4;
  }
`

export const DropdownButton = styled.button`
  width: 100%;
  min-height: 38px;
  padding: 0 12px;
  border: 0;
  border-radius: 9px;
  display: flex;
  align-items: center;
  background: transparent;
  color: #6f6f6f;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: #e90000;
    background: #faf4f4;
  }
`

export const AuthDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const RegistryLink = styled.button`
  border: 0;
  background: transparent;
  color: #e90000;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
`

export const ModalButton = styled.button`
  min-height: 42px;
  padding: 0 22px;
  border: 1px solid #343434;
  border-radius: 999px;
  background: #ffffff;
  color: #343434;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    color: #e90000;
    border-color: #e90000;
  }
`

export const NotificationMenu = styled.div`
  position: relative;
`

export const NotificationButton = styled.button`
  position: relative;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(40, 40, 40, 0.08);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #3f3f3f;
  cursor: pointer;
  transition: 0.2s ease;

  svg {
    font-size: 17px;
  }

  &:hover {
    color: #e90000;
    border-color: rgba(233, 0, 0, 0.2);
    background: #fff8f8;
  }
`

export const NotificationBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border: 2px solid #fff;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e90000;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
`

export const NotificationPanel = styled.div`
  position: absolute;
  top: calc(100% + 12px);
  right: -58px;
  width: min(390px, calc(100vw - 24px));
  max-height: 520px;
  overflow: hidden;
  border: 1px solid rgba(40, 40, 40, 0.08);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(25, 25, 25, 0.16);

  @media (max-width: 680px) {
    position: fixed;
    top: 64px;
    right: 12px;
  }
`

export const NotificationHeader = styled.div`
  min-height: 68px;
  padding: 14px 16px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  > div {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  strong {
    color: #2f2f2f;
    font-size: 15px;
  }

  span {
    color: #8a8a8a;
    font-size: 10px;
  }

  button {
    border: 0;
    background: transparent;
    color: #d60000;
    font-size: 10px;
    font-weight: 700;
    cursor: pointer;
  }
`

export const NotificationList = styled.div`
  max-height: 440px;
  overflow-y: auto;
`

type NotificationItemProps = {
  $unread?: boolean
}

export const NotificationItem = styled.div<NotificationItemProps>`
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid #f1f1f1;
  background: ${({ $unread }) => ($unread ? '#fff8f8' : '#fff')};

  &:last-child {
    border-bottom: 0;
  }
`

export const NotificationAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #f2f2f2;
`

export const NotificationBody = styled.button`
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;

  strong {
    display: block;
    color: #373737;
    font-size: 12px;
    line-height: 1.45;
    font-weight: 600;
  }

  span {
    display: block;
    margin-top: 4px;
    color: #999;
    font-size: 9px;
  }
`

export const NotificationActions = styled.div`
  grid-column: 2;
  display: flex;
  gap: 7px;
  margin-top: 2px;

  button {
    min-height: 30px;
    padding: 0 11px;
    border: 1px solid #dddddd;
    border-radius: 999px;
    background: #fff;
    color: #666;
    font-size: 10px;
    font-weight: 700;
    cursor: pointer;
  }

  button.primary {
    border-color: #e90000;
    background: #e90000;
    color: #fff;
  }
`

export const NotificationEmpty = styled.div`
  padding: 34px 20px;
  color: #8b8b8b;
  font-size: 12px;
  text-align: center;
`

export const MobileMenuButton = styled.button`
  display: none;

  @media (max-width: 760px) {
    display: inline-flex;
    justify-self: end;
    width: 44px;
    height: 44px;
    border: 1px solid rgba(40, 40, 40, 0.12);
    border-radius: 50%;
    background: #ffffff;
    color: #343434;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(30, 30, 30, 0.06);

    svg {
      font-size: 22px;
    }
  }
`

export const MobileMenuOverlay = styled.div`
  display: none;

  @media (max-width: 760px) {
    position: fixed;
    inset: 0;
    z-index: 1300;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 12px;
    background: rgba(22, 22, 22, 0.52);
    backdrop-filter: blur(5px);
  }
`

export const MobileMenuSheet = styled.div`
  width: min(100%, 520px);
  max-height: min(82vh, 720px);
  overflow-y: auto;
  padding: 16px;
  border: 1px solid rgba(40, 40, 40, 0.08);
  border-radius: 22px 22px 18px 18px;
  background: #ffffff;
  box-shadow: 0 -20px 50px rgba(20, 20, 20, 0.2);
`

export const MobileMenuHeader = styled.div`
  min-height: 54px;
  padding: 2px 2px 12px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  > div {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  > div > span {
    color: #929292;
    font-size: 10px;
  }
`

export const MobileMenuTitle = styled.strong`
  color: #2f2f2f;
  font-size: 18px;
  font-weight: 800;
`

export const MobileMenuClose = styled.button`
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  background: #f3f3f3;
  color: #333333;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
`

export const MobileNav = styled.nav`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
`

type MobileNavProps = {
  $active?: boolean
}

export const MobileNavLink = styled(Anchor)<MobileNavProps>`
  min-height: 50px;
  padding: 0 14px;
  border: 1px solid
    ({ $active }) =>
      $active ? 'rgba(233, 0, 0, 0.2)' : 'rgba(40, 40, 40, 0.08)';
  border-radius: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: ({ $active }) => ($active ? '#fff5f5' : '#fafafa');
  color: ({ $active }) => ($active ? '#d90000' : '#3f3f3f');
  font-size: 13px;
  font-weight: 700;

  svg {
    flex: 0 0 auto;
    font-size: 16px;
  }
`

export const MobileNavButton = styled.button`
  min-height: 50px;
  padding: 0 14px;
  border: 1px solid rgba(40, 40, 40, 0.08);
  border-radius: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fafafa;
  color: #3f3f3f;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;

  svg {
    flex: 0 0 auto;
    font-size: 16px;
  }

  strong {
    margin-left: auto;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e90000;
    color: #ffffff;
    font-size: 9px;
  }

  &.signout {
    width: 100%;
    margin-top: 8px;
    justify-content: center;
    border-color: rgba(233, 0, 0, 0.12);
    background: #fff7f7;
    color: #c80000;
  }
`

export const MobilePrimaryLink = styled(Anchor)`
  min-height: 50px;
  padding: 0 16px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  background: #e90000;
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(233, 0, 0, 0.16);
  font-size: 13px;
  font-weight: 800;

  &:hover {
    color: #ffffff;
    background: #cc0000;
  }
`

export const MobileAuthRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`

export const MobileAuthButton = styled.button`
  min-height: 48px;
  border: 1px solid #d9d9d9;
  border-radius: 13px;
  background: #ffffff;
  color: #333333;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;

  &.primary {
    border-color: #e90000;
    background: #e90000;
    color: #ffffff;
  }
`

export const MobileSection = styled.section`
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #eeeeee;
`

export const MobileSectionTitle = styled.div`
  margin-bottom: 8px;
  color: #7f7f7f;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`

export const MobileNotificationList = styled.div`
  margin-top: 10px;
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid #ececec;
  border-radius: 13px;
  background: #ffffff;
`

export const MobileNotificationEntry = styled.div`
  padding: 11px 12px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: 0;
  }

  > button:first-child {
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: left;
    cursor: pointer;
  }

  > button:first-child strong {
    display: block;
    color: #3b3b3b;
    font-size: 11px;
    line-height: 1.45;
  }

  > button:first-child span {
    display: block;
    margin-top: 4px;
    color: #999999;
    font-size: 8px;
  }
`
